import IconFuelSmall from '@/icons/icon-fuel-small';
import { Button } from '@/shadcn-ui/button';
import { colors } from '@/theme/colors';
import PageBanner from '@/common/components/page-banner';
import { BannerVariants } from '@/common/components/banner';
import { Link } from 'react-router';

interface GasSaverBannerProps {
  gasSaverCents: string;
  isSticky?: boolean;
  variant?: BannerVariants;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export default function GasSaverBanner({
  gasSaverCents,
  isSticky,
  variant = 'blue-bg-no-spacer',
  ref,
}: GasSaverBannerProps) {
  const learnMore = (
    <Link to="/save-on-gas" reloadDocument={true}>
      <Button variant="clear" className="body3 inline h-[20px] underline">
        Learn more
      </Button>
    </Link>
  );

  const bannerContent = (
    <>
      <div className="flex flex-row items-center justify-center gap-[4px] md:hidden">
        <IconFuelSmall
          className="h-[16px] w-[16px] flex-shrink-0 pt-[4px]"
          fillPrimary={colors.neutral1}
        />
        <p className="body3 text-left">
          <span className="body3-strong mr-[4px]">NEW! Flexcar Gas Saver™</span> Save{' '}
          {gasSaverCents}/gal at Sunoco. {learnMore}
        </p>
      </div>
      {/* Desktop */}
      <p className="body3 hidden md:block">
        <IconFuelSmall
          className="mr-[4px] inline h-[16px] w-[16px] align-text-bottom"
          fillPrimary={colors.neutral1}
        />
        <span className="body3-strong">NEW! Flexcar Gas Saver™</span> Save{' '}
        {gasSaverCents}/gal at Sunoco. {learnMore}
      </p>
    </>
  );

  return (
    <PageBanner ref={ref} isSticky={isSticky} variant={variant}>
      {bannerContent}
    </PageBanner>
  );
}
